import { ArrayUtils, StringUtils } from "neo-common";
import { Configuration } from "../Components/Configuration";
import { Scaling } from "../Utils/Scaling";
import { StageController } from "../Components/StageController";
import { ILayoutElement } from "../CustomComponents/ILayoutElement";

export class LayoutManager {
    protected static readonly ExtraPortraitClass: string = "extendPortrait";

    protected static LayoutElements: Array<ILayoutElement> = [];

    protected width: Array<number>;

    protected height: Array<number>;

    protected ratioIntervals: Array<Array<number>>;

    protected configured: boolean;

    constructor() {
        this.configured = false;
        this.ratioIntervals = [];

        let config: Element = Configuration.Configurations["LayoutManagerConfiguration"];
        if (config != null) {
            this.configurate(config);
            this.configured = true;
        }

        if (Scaling.Emitter != null) {
            Scaling.Emitter.on(Scaling.EventResize, this.onLayoutChange.bind(this));
        }
    }

    public static addLayoutElement(layoutElement: ILayoutElement): void {
        LayoutManager.LayoutElements.push(layoutElement);
    }

    private configurate(node: Element): void {
        if (node.hasAttribute(LayoutManagerConfigurationAttributes.WIDTH)) {
            this.width = ArrayUtils.numberArray(node.getAttribute(LayoutManagerConfigurationAttributes.WIDTH));
        }

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.HEIGHT)) {
            this.height = ArrayUtils.numberArray(node.getAttribute(LayoutManagerConfigurationAttributes.HEIGHT));
        }

        if (node.hasAttribute(LayoutManagerConfigurationAttributes.RATIO_INTERVALS)) {
            let intervals = ArrayUtils.stringArray(
                node.getAttribute(LayoutManagerConfigurationAttributes.RATIO_INTERVALS),
                "|",
            );

            for (let i = 0; i < intervals.length; i++) {
                this.ratioIntervals.push(ArrayUtils.numberArray(intervals[i]));
            }
        }
    }

    private onLayoutChange(isPortrait: boolean, ratio: number): void {
        if (!this.configured) {
            return;
        }

        isPortrait = this.allowedPortraitLayout(isPortrait, ratio);

        if (isPortrait) {
            document.body.classList.add(LayoutManager.ExtraPortraitClass);
        } else {
            document.body.classList.remove(LayoutManager.ExtraPortraitClass);
        }

        this.changeCanvasSize(isPortrait);
        this.updateLayoutElements(isPortrait);
    }

    private allowedPortraitLayout(isPortrait: boolean, ratio: number): boolean {
        if (this.ratioIntervals.length == 0) {
            return isPortrait;
        }

        if (isPortrait) {
            for (let i = 0; i < this.ratioIntervals.length; i++) {
                if (ratio > this.ratioIntervals[i][0] && ratio < this.ratioIntervals[i][1]) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    private changeCanvasSize(isPortrait: boolean): void {
        if (isPortrait) {
            StageController.Renderer.resize(this.width[1], this.height[1]); //portrait
        } else {
            StageController.Renderer.resize(this.width[0], this.height[0]); //landscape
        }

        //ToDo render only if renderer is paused
        StageController.Renderer.render(StageController.Stage);
    }

    private updateLayoutElements(isPortrait: boolean): void {
        for (let i = 0; i < LayoutManager.LayoutElements.length; i++) {
            LayoutManager.LayoutElements[i].onLayoutChange(isPortrait);
        }
    }
}

export const LayoutManagerConfigurationAttributes = {
    USE_ORIENTATION: "UseOrientation",
    HEIGHT: "Height",
    WIDTH: "Width",
    RATIO_INTERVALS: "RatioIntervals",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Managers/LayoutManager.ts
 **/